
































































































import {Component, Vue} from "vue-property-decorator";
import {delNullProperty} from "@/utils/index";
import axios from "axios";
import {Loading} from "element-ui";
import clue_select from './clue_select.vue';
import vantSelect from './vant-newselect.vue'
import {makeUploadSignature} from "@/utils/uploadMd5";
@Component({
  name: "AppLicationForm",
  components: {clueSelect: clue_select, vantSelect}
})
export default class extends Vue {
  private show = false;
  private gradeShow = false;  //年级
  private directionShow = false;  //咨询专业方向
  private grade = "";
  private gradeList = [
    {label: 'Grade 7', value: '美制7年级/英制8年级/初一（普高）'},
    {label: 'Grade 8', value: '美制8年级/英制9年级/初二（普高）'},
    {label: 'Grade 9', value: '美制9年级/英制10年级/初三（普高）'},
    {label: 'Grade 10', value: '美制10年级/英制11年级/高一（普高）'},
    {label: 'Grade 11', value: '美制11年级/英制12年级/高二（普高）'},
    {label: 'Grade 12', value: '美制12年级/英制13年级/高三（普高）'},
    {label: 'Freshmen', value: '大学一年级'},
    {label: 'Sophmore', value: '大学二年级'},
    {label: 'Junior', value: '大学三年级'},
    {label: 'Senior', value: '大学四年级'},
    {label: 'Graduate Student', value: '研究生及以上'},
    {label: 'Graduated', value: '已毕业'}
  ];
  private marketName = "";
  private phone = "";
  private weChat = "";
  private email = "";
  private remark = "";
  // private direction = "";
  private gradeVal = "";
  private specialized = "";
  private errorInfos = {
    // 存放对应输入框的报错信息，在提交的时候统一验证
    name: "",
    phone: "",
    weChat: "",
    email: "",
    grade: "",
    specialized: "",
    attendSchool: "",
    customerBusinessDataList: ""
  };

  private schoolShow = false;
  private attendSchool = '';
  private schoolList = [];
  private schoolId = '';
  private schoolName = null;
  private page = 1;
  private directorUserId = "";
  private from: "market" | "customer" = "market";
  private axios = null;
  private resultSuccess = false; // 提交成功
  private resultError = false
  private filelist = null
  private fileName = ''
  // private baseUrl = ''
  private customerBusinessDataList = []
  private loading = null
  private axios1: any = null;

  get baseUrl() {
    let str = '/upload/upload'
    if (process.env.NODE_ENV !== "development") {
      if (window.location.origin.includes('-testserver')) {
        str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
      } else {
        str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
      }
    }
    return str
  }


  created() {
    const query = this.$route.query;
    this.directorUserId = query.userId as string;
    // this.from = query.from as "market" | "customer";
    this.createAxios1();
    this.createAxios();
  }

  mounted() {
    this.setDocumentFontSize();
    window.addEventListener("resize", this.setDocumentFontSize);

  }


  createAxios() {
    const origin = location.hostname; //当前访问域名
    let requestBase = "";
    if (process.env.NODE_ENV === "development") {
      requestBase = process.env.VUE_APP_BASE_CRM_API_PROXY;
    } else {
      if (origin.indexOf("-testserver") > -1) {
        requestBase = process.env.VUE_APP_DEV_API;
      } else {
        requestBase = process.env.VUE_APP_MASTER_API;
      }
    }
    const config = {
      baseURL: requestBase,
      timeout: 30 * 1000, // Timeout
    };

    this.axios = axios.create(config);
  }

  createAxios1() {
    const origin = location.hostname; //当前访问域名
    let requestBase = "";
    if (process.env.NODE_ENV === "development") {
      requestBase = process.env.VUE_APP_BASE_FILE_API_PROXY;
    } else {
      if (origin.indexOf("-testserver") > -1) {
        requestBase = process.env.VUE_APP_DEV_FILE_API;
      } else {
        requestBase = process.env.VUE_APP_MASTER_FILE_API;
      }
    }
    const config = {
      baseURL: requestBase,
      timeout: 30 * 1000, // Timeout
    };
    this.axios1 = axios.create(config);
  }


  destroyed() {
    document.documentElement.style.fontSize = "16px";
  }


  showPopup() {
    this.schoolShow = true
  }

  handleSchool(data) {
    this.schoolList = data
  }

  listenSchool(data) {
    if (data != false) {
      this.schoolId = data.id
      this.attendSchool = data.text
    }

    this.schoolShow = false
  }


  gradeShowPopup() { //年级
    this.gradeShow = true
  }

  // 年级
  listenGrade(data) {
    if (data) {
      this.grade = data.label
      this.gradeVal = data.value
    }
    this.gradeShow = false
  }

  directionShowPopup() { //咨询专业方向
    this.directionShow = true
  }
  onFileChange1 (event1) {
    // 解决先上传成功在弹loding
    const event = event1
    let loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(()=>{
        this.onFileChange(event, loading)
      }, 800)
  }
  async onFileChange(event: any, loading: any) {
    this.filelist = event.target.files;

    // 检查文件数量限制
    if ((Number(this.filelist.length) + Number(this.customerBusinessDataList.length)) > 3) {
      alert('Upload up to 3 files');
      loading.close();
      return;
    }

    const arr = [];
    const uploadPromises = [];

    // 遍历文件列表创建上传 Promise
    for (let i = 0; i < this.filelist.length; i++) {
      const file = this.filelist[i];
      const formData = new FormData();
      formData.append("file", file);

      formData.append('file', file, file.name);
      formData.append('bucket', 'crm');
      const signature = makeUploadSignature('crm', file.name)
      formData.append('signature', signature);
      // 创建单个文件的上传 Promise
      const promise = this.axios1.post(this.baseUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res: any) => {
        // 假设 res 结构与你之前 $.ajax 的 success 回调一致
        // 如果 axios 拦截器已经处理了 data 解包，这里直接是 res.data
        // 根据原代码 res.error.returnCode，推测原始响应结构包含 error 字段
        const responseData = res.data;

        if (responseData.error && responseData.error.returnCode !== 0) {
          alert(responseData.error.returnMessage);
          throw new Error("Upload failed"); // 中断当前文件上传逻辑
        }

        // 返回成功的数据对象
        return { name: responseData.data.name, url: responseData.data.ossUrl };
      }).catch((err: any) => {
        alert("File upload failed！");
        throw err;
      });

      uploadPromises.push(promise);
    }

    try {
      // 等待所有文件上传完成 (并行上传，如需串行可改为 await 循环)
      // 原代码是同步循环，这里改用 Promise.all 并行处理以提高效率
      // 如果必须严格串行，可使用 for...of 循环配合 await
      const results = await Promise.all(uploadPromises);

      // 过滤掉可能的 undefined (如果有某个失败被捕获但未抛出)
      const validResults = results.filter(item => item !== undefined);

      this.customerBusinessDataList = [...this.customerBusinessDataList, ...validResults];

      // 清空 input value
      const fileInput = document.getElementById("txtFile") as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
    } catch (error) {
      console.error("Some files failed to upload", error);
    } finally {
      loading.close();
    }
  }

  deleteFlie (index) {
    this.customerBusinessDataList.splice(index, 1)
  }

  submitForm() {
    let isComplete = true;
    /* 清空报错信息 */
    for (const key in this.errorInfos) {
      this.errorInfos[key] = "";
    }
    /* 非空验证 */
    if (this.checkNull(this.marketName)) {
      this.errorInfos.name = "Please input Full Name";
      isComplete = false;
    }
    if (this.checkNull(this.phone)) {
      this.errorInfos.phone = "Please input Phone No.";
      isComplete = false;
    }
    if (this.checkNull(this.weChat)) {
      this.errorInfos.weChat = "Please input WeChat No.";
      isComplete = false;
    }

    if (this.checkNull(this.grade)) {
      this.errorInfos.grade = "Please input Grade";
      isComplete = false;
    }
    if (this.attendSchool.length == 0) {
      this.errorInfos.attendSchool = "Please input School";
      isComplete = false;
    }

    if (this.checkNull(this.email)) {
      this.errorInfos.email = "Please input Email Address ";
      isComplete = false;
    }

    if (this.checkNull(this.specialized)) {
      this.errorInfos.specialized = "Please input Targeted Major";
      isComplete = false;
    }
    // console.log('this', this)
    if (this.customerBusinessDataList.length == 0) {
      this.errorInfos.customerBusinessDataList = "Please upload data";
      isComplete = false;
    }

    if (isComplete) {
      // if (this.from === "customer") {
      this.setMarketClueByQrcode();
      // }
    }
  }

  checkNull(value: string | number): boolean {
    return ["", null, undefined, NaN].includes(value);
  }

  // 提交市场线索
  async setMarketClueByQrcode() {
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.axios
        .post(
            "/customer/setCustomerBusinessByInspire",
            delNullProperty({
              name: this.marketName,
              phone: this.phone,
              weChat: this.weChat,
              email: this.email,
              grade: this.gradeVal,
              school: this.attendSchool,
              specialized: this.specialized,
              customerBusinessDataList: this.customerBusinessDataList,
            })
        )
        .then(({data}) => {
          // 判断错误状态
          const error = data.error;
          if (error.returnCode === 1) {
            this.errorInfos.name = error.returnMessage;
          }
          if (error.returnCode === 0) {
            this.resultSuccess = true;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
          this.resultError = true
        });
  }

  closePage() {
    window.open("about:blank", "_self").close();
  }

  // 设置跟元素字体大小
  private setDocumentFontSize() {
    document.documentElement.style.fontSize =
        document.documentElement.getBoundingClientRect().width / 7.5 + "px";
  }


}
